import { SxProps, Theme } from '@mui/material';

export const loaderContainer: SxProps<Theme> = {
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
};
